export default __webpack_public_path__ + "static/media/Konzession.83a91cca.svg";